const __WEBPACK_NAMESPACE_OBJECT__ = require("@telia-company/tv.web-player-shared");